module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-4"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("EAGAN")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("CLOSED")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "sc"
  }), _vm._v("door to his stateroom, still thinking about the hottie with the body next door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A cursory glance around the room confirmed it was nice—luxurious even—but he was more interested in getting to know why a woman like her was on a singles cruise, much less "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("single")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yeah, because let’s face it...you get a girl like that...you lock that shit down tight.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not that he was a caveman or anything, but a woman with smoking curves like hers could turn any levelheaded man into a ground-pounding, chest-thumping gorilla.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maybe J.T. had booked him on a...swingers cruise or something. Like that trip in Jamaica where all the people in a certain lifestyle flocked to get their groove on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("J.T. had mentioned he wanted Teagan to “whoop it up,” whatever that meant. And knowing J.T., that could mean virtually anything.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Plus J.T. would laugh his balls off sending Teagan on a swingers cruise without his knowledge.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A laugh a minute, little brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("God, he hoped not.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wasn’t the sharing type.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And J.T. knew that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Okay, let’s go out on a limb and assume that J.T. is not that big of an asshole")]), _vm._v("—particularly to the brother who’d saved his ass in Mexico—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and safely assume that this cruise is exactly as it was booked")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Singles looking to mingle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ugh")]), _vm._v(". He cringed at the very idea of walking around, acting like a horny dog, sniffing after eligible ladies in the hopes of a hook-up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“J.T., you’re an ass,” he muttered, glancing around the room, wondering what his next step was. Was he supposed to do something? Go somewhere?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Was there an itinerary?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Teagan checked the nightstand, the bathroom and the small coffee table but found nothing to tell him what was in store for the next week. He sure as hell didn’t want to sit around twiddling his thumbs in his room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was bad enough he was going to be floating around without any work to keep him busy, but the threat of completely idle time gave him the willies.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His gaze traveled to the opposite wall, knowing Little Miss Hot Stuff was on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Either fate had one damn fine sense of humor or was a mean bitch, because that woman was going to be hard to put out of his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Teagan didn’t know anything about her aside from the fact that he wanted to know her better.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But there was something cheesy about knocking on his neighbor’s door with such an obvious pickup line, right?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Well, she did board a singles cruise, so that implied she was interested in meeting up with people, he reasoned.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or maybe she’d been roped into this gig, same as Teagan, and just wanted to get through it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Guess there was only one way to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hell, there was no harm in being friendly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Teagan smoothed his hair and then exited his room to knock on his neighbor’s door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She opened it with a subtle frown until she saw him. “Yes?” A slow quizzical smile followed, and he started stuttering like a jackass who’d never been around a female in his life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh, so here’s the thing... I have no idea what I’m supposed to be doing. And...forgive me if I sound like a perv, but...is this by any chance a swingers cruise?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Way to lead with something nonthreatening, dude.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her smile faltered but she didn’t slam the door in his face—good sign—then answered, “No, it’s for singles. Why? Were you looking for a swingers cruise?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, not all!” Teagan smiled with relief. “Thank God. I’m not into that swapping business. I mean, no judgment for those who are, but I’m not the type who enjoys sharing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good to know,” she said, mildly amused. “Was there anything else...?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Well, he was batting a thousand. Had he completely forgotten how to flirt?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Apparently.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The rust was practically grinding his gears. At one time, he’d been damn near the cat’s meow. Now he couldn’t even make simple conversation. Oh, how the mighty had fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Time for some damage control.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My brother booked this cruise for me and I’m...sort of flying blind,” he said by way of apology.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A spark of reluctant interest lit up her blue eyes. “Does your brother always book your vacations?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hell no. I don’t usually have time to vacation, but even if I did, I wouldn’t let J.T. take on that job. He and I have different ideas of what constitutes fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She crossed her arms lightly as if amused. “So why did your brother book you on a singles cruise?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not a story you want to hear standing in a hallway. It’s more of an over-dinner conversation,” he said with a grin. “Maybe with some wine, good food, excellent company.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, is that so?” she said, one eyebrow lifting. “And what makes it worth all that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Teagan held up three fingers then said, “Three words—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("plane crash")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("corporate intrigue")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("danger")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I see math is not your strong suit.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know... I can count quite clearly how you plus me equals a cozy dinner for two. How about it? I know you want to hear this story.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She laughed. “No doubt you’re the hero in this tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t mean to brag, but I did my part.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Let me guess, you’re a covert operative in the CIA and you were on a super secret international mission,” she teased, clearly not buying an ounce of his story. The irony was that his story was absolutely true. Although, he wasn’t supposed to talk about it. Confidentiality and all that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry to disappoint, but not the CIA,” Teagan said with a half grin. “Just a private pilot with a charter who got lucky. Or unlucky, depending on how you look at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where’d you learn to fly?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The US Air Force.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hmm.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Usually that sentence prompted more interest. He wasn’t one to use his service to open doors or drop panties, but he was a bit surprised by her lack of reaction. “Got bad history with a flyboy?” Teagan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. Not at all. I just don’t like people lying about time in the service. Some things should be sacred.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Teagan lost his smile. She thought he was lying? That was a new one. He straightened, quick to set her mind at ease, because it didn’t sit right to be accused of doing something he abhorred. “You’re right,” he agreed, seeming to surprise her with his firm tone. “People who lie about serving their country are the lowest scum and I can assure you, there is no stolen valor here. I served my country willingly, as did my brother. Now we own a private charter plane business here in Los Angeles.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What is your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Teagan Carmichael. And yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Again that enigmatic smile but no reciprocal answer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not gonna share?” he asked, drinking in every bit of her. She was so pretty, looking at her nearly hurt his eyes. There was something so untouchable about her, like a queen gracing her people with a glance and a subtle wave. “Seems kinda the point of this trip, right? Getting to know people?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At that, she answered, “Harper Riley,” and he nearly crowed with happiness. He had a name!")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice to meet you, Harper.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Likewise, Teagan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They were off to a decent start.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So...about that dinner...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Harper wasn’t as charmed as Teagan had thought because she flat out turned him down.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then she closed the door firmly in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Well, hell, that was not a good sign at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("ARPER")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("CLOSED")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "sc"
  }), _vm._v("door with a frown.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Why were the charming ones always broke as hell?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His idea of a good time probably included a monster truck rally and convenience store hot dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Definitely not to her standard.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But, he was certainly nice to look at.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Damn, when was the last time she got to choose based on chemistry?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Boohoo, life’s rough. Stop crying and start focusing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Stuart Buck was the real prize.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vulnerable, looking for someone to share his life with and hopefully old-fashioned when it came to prenups—as in he didn’t believe in them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper pulled her phone from her purse to refresh her mind with all the research she had archived on the old billionaire.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His wife, Rachel, had been the quintessential silent partner, standing behind her man as he’d built his empire, smiling with adoration at the man who’d revolutionized the toilet industry.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Props to you, Rachel")]), _vm._v(", Harper thought with derision. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I could never do that.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper was more about the end game than the building game.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And Stuart was nicely set up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He owned property in the Hamptons, a Manhattan apartment, a log cabin in Vail and, of course, his palatial mansion on Nob Hill in San Francisco, as well as his well-appointed beach house in Santa Barbara.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("An excited tingle tickled her stomach. She loved the thrill of the hunt, especially when the prize was fat and juicy like Stuart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper would do her best to help Stuart move on from the death of Perfect Wifey Number 1.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Because life was for the living.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And it wasn’t as if his wife was going to spend his millions.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A small smile found her, but, in spite of her plans to go over her research, Harper’s thoughts drifted to her cute neighbor.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She certainly knew that type. Teagan Carmichael was the kind of man her mother would’ve tripped all over herself to land. But even if Anna Riley had never learned, Harper had gotten the message loud and clear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Charming men were the first to bail when things got tough—or when they’d taken everything there was to take.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Poor Mom. In love with being in love. Eternally hopeful that the next guy was the one.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper would watch as men walked in and out of Anna’s life, leaving her with less and less.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If a man had bad credit, was nearly homeless, with a string of abandoned baby mamas, but could charm her with a seemingly devoted smile, Anna was all in.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But if Anna was continually blinded by love, Harper had become jaded by it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Especially after Rex Harrington. Or whatever his name truly was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Just the thought of Rex and what he’d done to her mother—and by proxy, her—made Harper want to throw something.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So, it didn’t matter that Teagan was the kind of man who took her breath away. His cute face and tight behind weren’t going to pay her bills.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tonight was the dinner and dance mixer. She’d already arranged to be seated at Stuart’s table. No doubt she’d have to fend off her share of competition, but this wasn’t her first rodeo.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She pulled up Stuart’s picture. Not bad looking. Bald but not fat—that was a plus.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her last target had been as jolly as Santa Claus in the waistband, but not quite as pleasant in his demeanor.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tried not to remember the times when his slobbery kisses had nearly made her retch.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ulysses Prawner had been the worst.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A millionaire, but barely so, he’d liked to spend his money on women and toys. Harper had helped him in his endeavors.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Only, Ulysses hadn’t known when to stop. His investments couldn’t keep up with his spending and before long he’d come to Harper with a sob story.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Baby,” he’d implored as she’d packed her bags. “I’m just in a slump. Things will get better. They always do. Don’t go.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper had already been casing the next target and was eager to move on. Actually, she’d been relieved to find a reason to bail. “Ulysses, let’s not make this uncomfortable. What we had has run its course.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But I love you, baby,” he’d cried, grasping for her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d tried to find an ounce of compassion for the man, but the well had run dry.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pulling her hands free, she’d cast him a look filled with pity and walked out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not empty-handed, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Every gift, every bit of cash that flowed her way had gone into a secret account, as did all her investments.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Someday she’d have enough to be solvent on her own. No more chasing after wealthy old pricks, swallowing her dignity and pride to cater to their every whim.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Someday")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That’s why Stuart Buck was so important.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That old man was going to put a ring on her finger—without the protection of a prenup.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then, when he died, all of his assets would go to Harper.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No more scouring the society pages, frequenting country clubs and pretending to be someone she wasn’t just to make a dollar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No more stressing about how she was going to pay her mother’s care bill.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The woman was as dependent on Harper as a child was on its parent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Irony at its finest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Even as much as Harper was focused on the big picture, there were times when a forlorn sadness intruded on her thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d stopped feeling guilty a long time ago, but now and then, she wished she had the luxury of enjoying a normal relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Thankfully, that kind of wistful thinking didn’t happen often, but seeing someone like Teagan was always good for a little melancholy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The fact was, she didn’t want to rely on anyone but herself for her well-being. In this world, either you were on the bottom or the top. And she made sure she was never on the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper jerked a short breath in and refocused. “Stuart, you sweet, old man. You are never going to know what hit you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Harper slipped her phone back into her purse and disappeared into her bathroom to get ready.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The stage was set and the players ready.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Time for the performance.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-3"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e32eda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_Two.vue
// module id = 81
// module chunks = 0